// 任务列表路由
const TaskList = r => require.ensure(
  [],
  () => r(require('@/components/task-list/task-list.vue')),
  'TaskList'
)

// 中国赛晋级结果
const AdvanceCn = r => require.ensure(
  [],
  () => r(require('@/components/bloom-task/advance-cn/index.vue')),
  'AdvanceCn'
)

// 中国区域站证书，可以通用证书类
const Certificate = r => require.ensure(
  [],
  () => r(require('@/components/bloom-task/certificate/index.vue')),
  'Certificate'
)

// 中国区域站证书，可以通用证书类
const CertificateEmail = r => require.ensure(
  [],
  () => r(require('@/components/bloom-task/certificate/certificate-email.vue')),
  'Certificate'
)

// 确认组队
const ConfirmTeam = r => require.ensure(
  [],
  () => r(require('@/components/bloom-task/confirm-team/index.vue')),
  'ConfirmTeam'
)

// 任务的子任务列表
const TaskSublist = r => require.ensure(
  [],
  () => r(require('@/components/bloom-task/task-sublist/index.vue')),
  'TaskSublist'
)

const HonorCollection = r => require.ensure(
  [],
  () => r(require('@/components/bloom-task/task-sublist/HonorCollection.vue')),
  'TaskSublist'
)
const HonorListConfirmation = r => require.ensure(
  [],
  () => r(require('@/components/bloom-task/task-sublist/HonorListConfirmation.vue')),
  'TaskSublist'
)

// 个人参赛信息
const PersonalJoin = r => require.ensure(
  [],
  () => r(require('@/components/bloom-task/personal-jion/jion-info')),
  'PersonalJoin'
)

// 比赛成绩单
const PromotionCard = r => require.ensure(
  [],
  () => r(require('@/components/bloom-task/report-card/promotion-result')),
  'PromotionCard'
)
// 比赛成绩单
const AcademicReport = r => require.ensure(
  [],
  () => r(require('@/components/bloom-task/report-card/AcademicReport')),
  'PromotionCard'
)

// 公共邮箱页面
const CommonEmail = r => require.ensure(
  [],
  () => r(require('@/components/bloom-task/common-email/common-email')),
  'CommonEmail'
)

// 问卷过渡页
const Questionnaire = r => require.ensure(
  [],
  () => r(require('@/components/bloom-task/questionnaire/index.vue')),
  'Questionnaire'
)

// 分享过渡页
const Share = r => require.ensure(
  [],
  () => r(require('@/components/bloom-task/share/share')),
  'Share'
)

// 组别页面
const Group = r => require.ensure(
  [],
  () => r(require('@/components/bloom-task/group/index')),
  'Group'
)

// 组别页面
const infoDistribute = r => require.ensure(
  [],
  () => r(require('@/components/bloom-task/info-distribute/index')),
  'Group'
)

const NoAuthorityPage = r => require.ensure(
  [],
  () => r(require('@/components/bloom-task/task-sublist/NoAuthorityPage')),
  'NoAuthorityPage'
)
const predecessors = r => require.ensure(
  [],
  () => r(require('@/components/bloom-task/task-sublist/predecessors')),
  'NoAuthorityPage'
)
// // C页面
// const Result = r => require.ensure(
//   [],
//   () => r(require('@/components/bloom-task/result/index')),
//   'Group'
// )
export default [
  // 任务列表
  {
    path: '/TaskList/:seasonId',
    name: 'TaskList',
    component: TaskList
  },
  // 中国站晋级结果
  {
    path: '/AdvanceCn',
    name: 'AdvanceCn',
    component: AdvanceCn,
    meta: {
      title: ''
    }
  },
  // 中国区域站证书，可以通用证书类
  {
    path: '/TaskSublist/result',
    name: 'Certificate',
    component: Certificate,
    meta: {
      title: ''
    }
  },
  // 信息分发
  {
    path: '/TaskSublist/infoDistribute',
    name: 'infoDistribute',
    component: infoDistribute,
    meta: {
      title: ''
    }
  },
  // 没有任务权限
  {
    path: '/NoAuthorityPage',
    name: 'NoAuthorityPage',
    component: NoAuthorityPage,
    meta: {
      title: ''
    }
  },
  // 没有完成前置任务
  {
    path: '/predecessors',
    name: 'predecessors',
    component: predecessors,
    meta: {
      title: ''
    }
  },
  // 中国区域站证书，证书发送邮件
  {
    path: '/Certificate/Email',
    name: 'CertificateEmail',
    component: CertificateEmail,
    meta: {
      title: ''
    }
  },
  // 确认组队
  {
    path: '/ConfirmTeam',
    name: 'ConfirmTeam',
    component: ConfirmTeam,
    meta: {
      title: ''
    }
  },
  // 任务的子任务列表
  {
    path: '/TaskSublist',
    name: 'TaskSublist',
    component: TaskSublist,
    meta: {
      title: ''
    }
  },
  // 个人参赛信息
  {
    path: '/PersonalJoin',
    name: 'PersonalJoin',
    component: PersonalJoin
  },
  // 个人参赛信息
  {
    path: '/HonorCollection',
    name: 'HonorCollection',
    component: HonorCollection
  },
  {
    path: '/TaskSublist/honor',
    name: 'HonorListConfirmation',
    component: HonorListConfirmation
  },
  // 比赛成绩单
  {
    path: '/TaskSublist/promotionCard',
    name: 'PromotionCard',
    component: PromotionCard
  },
  // 学术报告页面
  {
    path: '/TaskSublist/academic',
    name: 'academic',
    component: AcademicReport
  },
  // 公共邮箱页面
  {
    path: '/CommonEmail',
    name: 'CommonEmail',
    component: CommonEmail
  },
  // 问卷调查
  {
    path: '/Questionnaire',
    name: 'Questionnaire',
    component: Questionnaire
  },
  // 分享
  {
    path: '/share',
    name: 'Share',
    component: Share
  },
  // 组别
  {
    path: '/group',
    name: 'Group',
    component: Group
  // },
  // // 组别
  // {
  //   path: '/result',
  //   name: 'Result',
  //   component: Result
  }
]



// WEBPACK FOOTER //
// ./src/router/sub-route/task-list.js